import TileProduct from './TileProduct'

export default TileProduct
// eslint-disable-next-line import/export
export * from './TileProduct'
